import React from 'react';
import { Link } from 'react-router-dom';
import './PageNotFound.scss';
import { Home, ArrowLeft, AlertCircle } from 'lucide-react';

const PageNotFound = (_props) => {
  return (
    <div className="modern-page-not-found">
      <div className="not-found-container">
        {/* Animated 404 */}
        <div className="error-code-section">
          <div className="error-code">404</div>
          <div className="error-icon">
            <AlertCircle size={64} />
          </div>
        </div>

        {/* Content */}
        <div className="error-content">
          <h1 className="error-title">Oops! Page Not Found</h1>
          <p className="error-description">
            The page you're looking for seems to have gone on a little adventure. 
            Don't worry, it happens to the best of us!
          </p>
        </div>

        {/* Action Buttons */}
        <div className="error-actions">
          <Link to="/" className="modern-btn primary-btn">
            <Home size={20} />
            <span>Back to Home</span>
          </Link>
          
          <button 
            onClick={() => window.history.back()} 
            className="modern-btn secondary-btn"
          >
            <ArrowLeft size={20} />
            <span>Go Back</span>
          </button>
        </div>

        {/* Decorative Elements */}
        <div className="floating-elements">
          <div className="floating-circle circle-1"></div>
          <div className="floating-circle circle-2"></div>
          <div className="floating-circle circle-3"></div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;